import src from "IMAGE";
export default { src, width: 491, height: 492, blurWidth: 0, blurHeight: 0};
